import Barcode from "react-barcode";
import styles from "./Print.module.css"
import nl2br from "react-nl2br";
import {formatDateFull} from "@/lib/utils/date";
import RenderIf from "@/components/render-if";


function ProductReceiptPrintV2({data}) {

    if (!data) return null;
    if(!data.product_delivery?.length) return null;

    return (
        <>
            <div className={styles.printRoot}>


            {data.product_delivery.filter(f => f.status === 'pending' || f.status === 'print' ).map((item) => (
                <div
                    key={item.id}
                    className={styles.receiptPage}
                >
                    <div className={'p-2 border dark:border-gray-600 border-gray-600 rounded-lg mb-2'}>
                        <div className={'flex justify-center flex-col items-center'}>
                            <div className={''}>
                                {document.title}
                            </div>

                            <div className={''}>
                                رسید تحویل اقلام آموزشی
                            </div>
                        </div>
                        <div className={styles.line}></div>

                        <div className="text-center">
                            <div className={'font-bold text-center text-2xl'}>{item?.product?.title}</div>
                            {item?.product?.description && <div>{nl2br(item?.product?.description)}</div>}
                        </div>

                        <div className={styles.line}></div>
                        <table>
                            <tbody>
                            <tr>
                                <td>نام</td>
                                <td>{data?.student_detail?.firstname} {' '}{data?.student_detail?.lastname} </td>
                            </tr>
                            <tr>
                                <td>کد ملی</td>
                                <td>{data?.student_detail?.nationalcode}</td>
                            </tr>
                            <tr>
                                <td>موبایل</td>
                                <td>{data?.student_detail?.mobile}</td>
                            </tr>
                            </tbody>
                        </table>

                        <div className={styles.line}></div>
                        <div className={'text-center flex flex-col items-center gap-1 justify-center'}>
                            <Barcode
                                value={item?.code}
                                format="CODE128"
                                height={45}
                                width={1.6}
                                margin={0}
                                displayValue={false}
                            />
                            <div className={' flex gap-2'}>
                                <div>کد تحویل</div>
                                <div className={'font-bold'}>{item?.code}</div>
                            </div>
                        </div>
                        <RenderIf condition={item?.product?.deliver_text}>
                            <div className={styles.line}></div>

                            <div className="">

                                {item?.product?.deliver_text && <div>{nl2br(item?.product?.deliver_text)}</div>}

                            </div>
                        </RenderIf>


                        <div className={styles.line}></div>

                        <div className={''}>
                            {formatDateFull(new Date())}
                        </div>
                    </div>
                </div>
            ))}
            </div>
        </>

    );

}

export default ProductReceiptPrintV2;